module.exports = __webpack_public_path__ + "static/media/Hand-min.444f2acd.PNG";